import React, { Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { CSpinner } from "@coreui/react";
import "./scss/style.scss";
import ProtectedRoute from "./components/ProtectedRoutes";
import Dashboard from "./views/dashboard/Dashboard";
import Login from "./views/login/Login";
import WhatsappRedirect from "./views/public/WhatsappRedirect";
import PasswordReset from "./views/login/PasswordReset";
import Logout from "./views/login/Logout";
import Page404 from "./views/page404/Page404";
import InovList from "./views/applications/inov/InovList";
import InovApplication from "./views/applications/inov/InovApplication";
import IdtApplication from "views/applications/idt/IdtApplication";
import IdtList from "views/applications/idt/IdtList";
import Projects from "views/management/Projects";
import Resources from "views/management/Resources";
import Holidays from "views/internalManagement/Holidays";
import Absences from "views/internalManagement/Absences";
import ClientsList from "views/clients/ClientsList";
import BillingUpdatesEmail from "views/clients/BillingUpdatesEmail";
import Surveillance from "views/management/Surveillance";
import Kpi from "views/projects/Kpi";
import ProjectsList from "views/roberto/ClientsList";
import ManagementClientProject from "views/roberto/ClientPage";
import ExternalManagementClient from "views/robertoExternal/ClientPage";
import NonConformity from "./views/nonconformities/NonConformity";
import InnovativeIdeaList from "./views/innovativeIdeas/InnovativeIdeaList";
import IdeaBankList from "./views/innovativeIdeas/IdeaBankList";
import InnovativeIdea from "./views/innovativeIdeas/InnovativeIdea";
import InnovationActionList from "views/innovationActions/InnovationActionList";
import IdiProjectList from "views/idiProjects/IdiProjectList";
import InnovationAction from "views/innovationActions/InnovationAction";
import IdeaList from "./views/ideas/IdeaList";
import Idea from "./views/ideas/Idea";
import ImprovementOppList from "./views/improvementOpps/ImprovementOppList";
import ImprovementOpp from "./views/improvementOpps/ImprovementOpp";
import NonConformityList from "./views/nonconformities/NonConformityList";
import ComplaintList from "./views/complaints/ComplaintList";
import Complaint from "./views/complaints/Complaint";
import ImprovementActionList from "./views/improvementActions/ImprovementActionList";
import ImprovementAction from "./views/improvementActions/ImprovementAction";
import UserList from "./views/users/UserList";
import User from "./views/users/User";
import EventList from "./views/events/EventList";
import Event from "./views/events/Event";
import EventReport from "./views/events/EventReport";
import EventEvaluationList from "./views/events/EventEvaluationList";
import EventEvaluation from "./views/events/EventEvaluation";
import CompetingCompanyList from "views/competitiveAnalysis/CompetingCompanyList";
import CompetingCompany from "views/competitiveAnalysis/CompetingCompany";
import CompetitionAnalysis from "views/competitiveAnalysis/CompetitionAnalysis";
import InterfaceSurveillanceList from "views/interfaceSurveillances/interfaceSurveillanceList";
import InterfaceSurveillance from "views/interfaceSurveillances/interfaceSurveillance";
import SatisfactionSurveyList from "views/satisfactionSurveys/satisfactionSurveyList";
import SatisfactionSurvey from "views/satisfactionSurveys/satisfactionSurvey";
import SupplierList from "views/suppliers/supplierList";
import Supplier from "views/suppliers/supplier";
import SuppliersEvaluation from "views/suppliers/supplierEvaluation";
import SupplierEvaluationWeightsPage from "views/supplierEvaluationWeights";
import PartnershipList from "views/partnerships/partnershipList";
import Partnership from "views/partnerships/partnership";
import IdiSurveyList from "views/idiSurveys/idiSurveyList";
import IdiSurvey from "views/idiSurveys/idiSurvey";
import Internship from "views/internships/internship";
import InternshipList from "views/internships/internshipList";
import InterList from "views/applications/inter/InterList";
import InterApplication from "views/applications/inter/InterApplication";
import ClientLayout from "components/ClientLayout";
import SstSurvey from "views/sstSurveys/sstSurvey";
import SstSurveyList from "views/sstSurveys/sstSurveyList";
import SstSurveyResults from "views/sstSurveys/sstSurveyResults";
import HappinessSurvey from "views/happinessSurveys/happinessSurvey";
import HappinessSurveyList from "views/happinessSurveys/happinessSurveyList";
import HappinessSurveyResults from "views/happinessSurveys/happinessSurveyResults";
import DepartmentList from "views/departments/departmentList";
import Department from "views/departments/department";
import DepartmentAllocationsPage from "views/departments/departmentAllocation";
import EvaluationLink from "views/departments/evaluationLink";
import SupervisoryAssessmentsPage from "views/supervisoryAssessments/index";
import PerformanceAssessmentsPage from "views/performanceAssessments/index";
import PerformanceAssessmentWeightsPage from "views/performanceAssessmentWeights";
import IndicatorsPage from "views/indicators/indicators";
import IndicatorChartsPage from "views/indicators/indicatorCharts";
import FunctionalObjectivesPage from "views/functionalObjectives/functionalObjectives";
import LearnedLessonList from "views/learnedLessons/LearnedLessonList";
import LearnedLesson from "views/learnedLessons/LearnedLesson";
import IntellectualPropertyList from "views/intellectualProperty/IntellectualPropertyList";
import IntellectualProperty from "views/intellectualProperty/IntellectualProperty";
import KickoffSessionList from "views/kickoffSessions/KickoffSessionList";
import KickoffSession from "views/kickoffSessions/KickoffSession";
import KickoffDeckList from "views/kickoffDeck/KickoffDeckList";
import CompanyFundingList from "views/companyFunding/CompanyFundingList";
import PresentialSatisfactionSurveyList from "views/presentialSatisfactionSurveys/PresentialSatisfactionSurveyList";
import PresentialSatisfactionSurvey from "views/presentialSatisfactionSurveys/PresentialSatisfactionSurvey";
import StreamPilotPanel from "views/streamPilot/StreamPilotPanel";
import StreamPilotSubagentPlayground from "views/streamPilot/StreamPilotSubagentPlayground";

const App = () => {
  return (
    <BrowserRouter>
      <Suspense
        fallback={
          <div className="pt-3 text-center">
            <CSpinner color="primary" variant="grow" />
          </div>
        }
      >
        <Routes>
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/candidaturas/inovacao" element={<InovList />} />
            <Route
              path="/candidaturas/inovacao/:id"
              element={<InovApplication />}
            />
            <Route path="/candidaturas/idt" element={<IdtList />} />
            <Route path="/candidaturas/idt/:id" element={<IdtApplication />} />
            <Route
              path="/candidaturas/internacionalizacao/:id"
              element={<InterApplication />}
            />
            <Route
              path="/candidaturas/internacionalizacao"
              element={<InterList />}
            />
            <Route path="/projetos/feed" element={<Projects />} />
            <Route path="/projetos/recursos" element={<Resources />} />
            <Route path="/projetos/vigilancia" element={<Surveillance />} />
            <Route path="/projetos/kickoff" element={<KickoffDeckList />} />
            <Route
              path="/projetos/fundos-europeus"
              element={<CompanyFundingList />}
            />
            <Route path="/interno/ferias" element={<Holidays />} />
            <Route path="/interno/ausencias" element={<Absences />} />
            <Route path="/projetos/kpis" element={<Kpi />} />
            <Route path="/projetos/gestao" element={<ProjectsList />} />
            <Route
              path="/projetos/gestao/:id"
              element={<ManagementClientProject />}
            />
            <Route path="/clientes" element={<ClientsList />} />
            <Route
              path="/clientes/atualizacoes-faturacao"
              element={<BillingUpdatesEmail />}
            />
            <Route path="/ideas" element={<Idea />} />
            <Route path="/ideas/create" element={<Idea />} />
            <Route path="/ideas/:id" element={<Idea />} />
            <Route
              path="/improvement-opportunities"
              element={<ImprovementOpp />}
            />
            <Route
              path="/improvement-opportunities/:id"
              element={<ImprovementOpp />}
            />
            <Route
              path="/improvement-actions"
              element={<ImprovementAction />}
            />
            <Route
              path="/improvement-actions/:id"
              element={<ImprovementAction />}
            />
            <Route path="/nonconformities" element={<NonConformity />} />
            <Route path="/nonconformities/create" element={<NonConformity />} />
            <Route path="/nonconformities/:id" element={<NonConformity />} />
            <Route path="/ideias-inovadoras" element={<InnovativeIdeaList />} />
            <Route path="/banco-ideias" element={<IdeaBankList />} />
            <Route path="/ideias-inovadoras/:id" element={<InnovativeIdea />} />
            <Route path="/ideias-inovadoras/new" element={<InnovativeIdea />} />
            <Route path="/acoes-inovacao" element={<InnovationActionList />} />
            <Route path="/acoes-inovacao/:id" element={<InnovationAction />} />
            <Route path="/projetos-idi" element={<IdiProjectList />} />
            <Route path="/ideias" element={<IdeaList />} />
            <Route path="/ideias/:id" element={<Idea />} />
            <Route path="/ideias/new" element={<Idea />} />
            <Route
              path="/oportunidades-melhoria"
              element={<ImprovementOppList />}
            />
            <Route
              path="/oportunidades-melhoria/:id"
              element={<ImprovementOpp />}
            />
            <Route
              path="/oportunidades-melhoria/new"
              element={<ImprovementOpp />}
            />
            <Route path="/acoes-melhoria" element={<ImprovementActionList />} />
            <Route path="/acoes-melhoria/:id" element={<ImprovementAction />} />
            <Route path="/acoes-melhoria/new" element={<ImprovementAction />} />
            <Route path="/nao-conformidades" element={<NonConformityList />} />
            <Route path="/nao-conformidades/:id" element={<NonConformity />} />
            <Route path="/nao-conformidades/new" element={<NonConformity />} />
            <Route path="/reclamacoes" element={<ComplaintList />} />
            <Route path="/reclamacoes/:id" element={<Complaint />} />
            <Route path="/reclamacoes/new" element={<Complaint />} />
            <Route path="/licoes-aprendidas" element={<LearnedLessonList />} />
            <Route path="/licoes-aprendidas/:id" element={<LearnedLesson />} />
            <Route path="/licoes-aprendidas/new" element={<LearnedLesson />} />
            <Route
              path="/propriedade-intelectual"
              element={<IntellectualPropertyList />}
            />
            <Route
              path="/propriedade-intelectual/:id"
              element={<IntellectualProperty />}
            />
            <Route path="/stream-pilot/:id" element={<StreamPilotPanel />} />
            <Route
              path="/stream-pilot/:id/subagents"
              element={<StreamPilotSubagentPlayground />}
            />
            <Route
              path="/propriedade-intelectual/new"
              element={<IntellectualProperty />}
            />
            <Route
              path="/questionarios-satisfacao-presencial"
              element={<PresentialSatisfactionSurveyList />}
            />
            <Route
              path="/questionarios-satisfacao-presencial/:id"
              element={<PresentialSatisfactionSurvey />}
            />
            <Route
              path="/questionarios-satisfacao-presencial/new"
              element={<PresentialSatisfactionSurvey />}
            />
            <Route path="/sessoes-arranque" element={<KickoffSessionList />} />
            <Route path="/sessoes-arranque/:id" element={<KickoffSession />} />
            <Route path="/sessoes-arranque/new" element={<KickoffSession />} />
            <Route path="/utilizadores" element={<UserList />} />
            <Route path="/utilizadores/:id" element={<User />} />
            <Route path="/utilizadores/new" element={<User />} />
            <Route path="/formacoes-eventos" element={<EventList />} />
            <Route path="/formacoes-eventos/:id" element={<Event />} />
            <Route path="/formacoes-eventos/new" element={<Event />} />
            <Route
              path="/formacoes-eventos/:id/relatorio"
              element={<EventReport />}
            />
            <Route
              path="/formacoes-eventos/:id/avaliacao"
              element={<EventEvaluationList />}
            />
            <Route
              path="/avaliacao-formacoes-eventos/:id"
              element={<EventEvaluation />}
            />
            <Route
              path="/vigilancia-interfaces"
              element={<InterfaceSurveillanceList />}
            />
            <Route
              path="/vigilancia-interfaces/new"
              element={<InterfaceSurveillance />}
            />
            <Route
              path="/vigilancia-interfaces/:id"
              element={<InterfaceSurveillance />}
            />
            <Route path="/inqueritos-idi" element={<IdiSurveyList />} />
            <Route path="/parcerias" element={<PartnershipList />} />
            <Route path="/parcerias/new" element={<Partnership />} />
            <Route path="/parcerias/:id" element={<Partnership />} />
            <Route path="/estagios" element={<InternshipList />} />
            <Route path="/estagios/new" element={<Internship />} />
            <Route path="/estagios/:id" element={<Internship />} />
            <Route
              path="/questionarios-satisfacao"
              element={<SatisfactionSurveyList />}
            />

            <Route path="/inqueritos-sst" element={<SstSurveyList />} />
            <Route path="/inqueritos-sst/new" element={<SstSurvey />} />
            <Route path="/inqueritos-sst/:id" element={<SstSurvey />} />
            <Route
              path="/inqueritos-sst/resultados/:year"
              element={<SstSurveyResults />}
            />
            <Route
              path="/inqueritos-felicidade"
              element={<HappinessSurveyList />}
            />
            <Route
              path="/inqueritos-felicidade/new"
              element={<HappinessSurvey />}
            />
            <Route
              path="/inqueritos-felicidade/:id"
              element={<HappinessSurvey />}
            />
            <Route
              path="/inqueritos-felicidade/resultados/:year"
              element={<HappinessSurveyResults />}
            />

            <Route path="/departamentos" element={<DepartmentList />} />
            <Route path="/departamentos/new" element={<Department />} />
            <Route path="/departamentos/:id" element={<Department />} />
            <Route
              path="/departamentos/:id/avaliacoes"
              element={<EvaluationLink />}
            />
            <Route
              path="/avaliacao-chefias"
              element={<SupervisoryAssessmentsPage />}
            />
            <Route
              path="/avaliacao-desempenho"
              element={<PerformanceAssessmentsPage />}
            />
            <Route path="/matriz-indicadores" element={<IndicatorsPage />} />
            <Route path="/resultados-indicadores" element={<IndicatorChartsPage />} />
            <Route path="/objetivos-funcionais" element={<FunctionalObjectivesPage />} />
            <Route
							path="/alocacao-departamentos"
							element={<DepartmentAllocationsPage />}
						/>
          </Route>
          <Route
            element={
              <ProtectedRoute requireClaim="can_access_competitive_analysis" />
            }
          >
            <Route
              path="/empresas-concorrentes"
              element={<CompetingCompanyList />}
            />
            <Route
              path="/empresas-concorrentes/:id"
              element={<CompetingCompany />}
            />
            <Route
              path="/empresas-concorrentes/new"
              element={<CompetingCompany />}
            />
            <Route
              path="/analise-concorrencia"
              element={<CompetitionAnalysis />}
            />
          </Route>
          <Route element={<ProtectedRoute managerOnly />}>
            <Route path="/fornecedores" element={<SupplierList />} />
            <Route path="/fornecedores/new" element={<Supplier />} />
            <Route path="/fornecedores/:id" element={<Supplier />} />
            <Route
              path="/avaliacao-fornecedores"
              element={<SuppliersEvaluation />}
            />
            <Route
              path="/ponderacoes-avaliacao-desempenho"
              element={<PerformanceAssessmentWeightsPage />}
            />
          </Route>
          <Route element={<ProtectedRoute staffOrManagerOnly />}>
            <Route
              path="/ponderacoes-avaliacao-fornecedores"
              element={<SupplierEvaluationWeightsPage />}
            />
          </Route>
          <Route
            path="/questionarios-satisfacao/:uuid"
            element={<SatisfactionSurvey />}
          />
          <Route path="/inqueritos-idi/:uuid" element={<IdiSurvey />} />
          <Route path="/wa/:phone" element={<WhatsappRedirect />} />
          <Route element={<ClientLayout />}>
            <Route
              path="/projetos/gestao/token/:token"
              element={<ExternalManagementClient />}
            />
          </Route>
          <Route path="/password-reset" element={<PasswordReset />} />
          <Route
            path="/password-reset/:uid/:token"
            element={<PasswordReset />}
          />
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Page404 />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default App;
